import React from 'react'

export default function TableHeader(props) {
  return (
    <div className={'tb-header ' + props.className}>
      {
        props.headers.map((item, index) => {
          return (
            <div key={index} className={'d-flex align-items-center fs-16 sm-fs-14 f-m color-878c91 ' + item.class}>
              <div className={item.center === false ? 'flex-full' : 'flex-full text-center'}>{item.name}</div>
              {
                item.divider !== false &&
                <div className='th-divider'/>
              }
            </div>
          )
        })
      }
    </div>
  )
}
